<div class="exit-clearance-container" *ngIf="exitClearance">
    <!-- Employee Details -->
    <div class="employee-details">
    </div>  

    <div class="employee-details">
      <h2>Employee Details</h2>
      <div style="display: flex; justify-content: space-between;">
        <div>
          <p><strong>Name:</strong> {{ exitClearance.exitClearance.employeeName }}</p>
          <p><strong>SAP ID:</strong> {{ exitClearance.exitClearance.employeeSAPId }}</p>
          <p><strong>Email:</strong> {{ exitClearance.exitClearance.employeeLAPEmail }}</p>
          <p><strong>Unit:</strong> {{ exitClearance.exitClearance.employeeUnitName }}</p>
          <p><strong>Function:</strong> {{ exitClearance.exitClearance.employeeFunctionName }}</p>
          <p><strong>Designation:</strong> {{ exitClearance.exitClearance.employeeDesignation }}</p>
          <p><strong>Last Working Date:</strong> {{ exitClearance.exitClearance.employeeLastWorkingDate | date: 'shortDate' }}</p>    
          <p><strong>Reason For Exit:</strong> {{ exitClearance.exitClearance.reasonForExit }}</p>    
          <p><strong>Need Medical Waiver:</strong> {{ exitClearance.exitClearance.needMedicalWaiver ? 'Yes' : 'No' }}</p>    
        </div>

        <div>
          <h4>Status: {{ exitClearance.exitClearance.status }}</h4>
        </div>

      </div>
      </div>
  
    <!-- Approval Details -->
    <div class="approval-details">
      <h2>Approval Details</h2>
      <table>
        <thead>
          <tr>
            <th>Checklist Description</th>
            <th>Approver</th>
            <th>Status</th>
            <th>Approval Date</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let approval of exitClearance.approvals">
            <td>{{ approval.description }}</td>
            <td>{{ approval.approverName }}</td>
            <td>{{ approval.status }}</td>
            <td>{{ approval.approvalDate | date: 'short' }}</td>
            <td>{{ approval.feedback }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="alert alert-info mt-3"
      *ngIf="showMedicalWaiverPrompt">

        <h5>Medical Waiver</h5>

        <p>
            Would you like to request a medical waiver for your exit clearance?
        </p>

        <button
            class="btn btn-success me-2"
            (click)="showWaiverModal = true">
            Yes
        </button>

        <button
            class="btn btn-secondary"
            (click)="showMedicalWaiverPrompt = false">
            No
        </button>

    </div>
    <button class="btn btn-primary" style="margin-right: 8px;" *ngIf="exitClearance.exitClearance.status ==  'Pending Employee Authorization'" (click)="approveExitClearance()">Confirm</button>
    <button class="btn btn-primary" style="margin-right: 8px;" *ngIf="exitClearance.exitClearance.status ==  'Pending'" (click)="handleSubmit()">Send Reminder</button>


  </div>

  <div
    class="modal fade show"
    tabindex="-1"
    [ngStyle]="{'display': showWaiverModal ? 'block' : 'none'}"
    *ngIf="showWaiverModal">

    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title">Medical Waiver Request</h5>

                <button
                    type="button"
                    class="btn-close"
                    (click)="showWaiverModal = false"> x
                </button>
            </div>

            <div class="modal-body">

                <label class="form-label">
                    Reason for requesting a medical waiver
                </label>

                <textarea
                    class="form-control"
                    rows="5"
                    [(ngModel)]="waiverReason"
                    placeholder="Enter reason...">
                </textarea>

            </div>

            <div class="modal-footer">

                <button
                    class="btn btn-secondary"
                    (click)="showWaiverModal = false">
                    Cancel
                </button>

                <button
                    class="btn btn-primary"
                    [disabled]="!waiverReason.trim()"
                    (click)="submitWaiver()">
                    Submit
                </button>

            </div>

        </div>
    </div>
</div>

<div
    class="modal-backdrop fade show"
    *ngIf="showWaiverModal">
</div>
  